export default function formatPhoneNumber(phone: string) {
    if (phone.startsWith('0')) {
        return `+61${phone.slice(1)}`;
    }
    if (phone.startsWith('61')) {
        return `+61${phone.slice(2)}`;
    }
    return `+61${phone}`;
}
